import { useMediaStore } from "@demo/store/media";

/**
 * Media Store Adapter
 *
 * This adapter provides an imperative API for accessing the media store
 * from non-React contexts (pure TypeScript utilities).
 *
 * React components should continue using the useMediaStore hook.
 * Pure TS utilities should import this adapter instead.
 */

export interface MediaStoreAdapter {
  getUserMediaSet: ReturnType<typeof useMediaStore.getState>["getUserMediaSet"];
  getSystemMediaSet: ReturnType<typeof useMediaStore.getState>["getSystemMediaSet"];
}

/**
 * Get the live media store adapter instance.
 * This returns the current state methods from the Zustand store.
 */
export function getMediaStoreAdapter(): MediaStoreAdapter {
  const state = useMediaStore.getState();
  return {
    getUserMediaSet: state.getUserMediaSet,
    getSystemMediaSet: state.getSystemMediaSet,
  };
}
